import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

const BaseCheckbox = ({
  contentPos = 'right',
  name,
  checked,
  indeterminate,
  onChange = () => {},
  children,
  ...props
}) => {
  return (
    <label {...props} className={styles.root}>
      <input
        type="checkbox"
        name={name}
        className={styles.input}
        checked={checked}
        onChange={onChange}
      />
      <span
        className={cn(styles.checkmark, {
          [styles.indeterminate]: indeterminate,
          [styles.leftPos]: contentPos === 'left',
        })}
      />

      {children}
    </label>
  );
};

export default BaseCheckbox;
